import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
// import { Panel } from 'primereact/panel';
import { Image } from 'primereact/image';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataView } from 'primereact/dataview';
import { Chip } from 'primereact/chip';
// import { Badge } from 'primereact/badge';
// import { Timeline } from 'primereact/timeline';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

interface OrderDetailsProps {
    visible: boolean;
    onHide: () => void;
    order: any;
    loading: boolean;
}

const OrderDetailsSidebar: React.FC<OrderDetailsProps> = ({ visible, onHide, order, loading }) => {
    // const orderStatusEvents = [
    //     { status: 'Order Placed', icon: 'pi pi-shopping-cart', color: '#9C27B0', date: 'Just now' },
    //     { status: 'Confirmed', icon: 'pi pi-check', color: '#673AB7', date: 'Processing' },
    //     { status: 'Preparing', icon: 'pi pi-cog', color: '#FF9800', date: 'In progress' },
    //     { status: 'Out for Delivery', icon: 'pi pi-truck', color: '#607D8B', date: 'Pending' },
    //     { status: 'Delivered', icon: 'pi pi-home', color: '#4CAF50', date: 'Pending' }
    // ];

    // const customizedMarker = (item: any) => {
    //     return (
    //         <span
    //             className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1"
    //             style={{ backgroundColor: item.color }}
    //         >
    //             <i className={item.icon}></i>
    //         </span>
    //     );
    // };

    // const customizedContent = (item: any) => {
    //     return (
    //         <Card className="mt-3">
    //             <div className="flex align-items-center">
    //                 <div className="flex-1">
    //                     <h5 className="mt-0 mb-1">{item.status}</h5>
    //                     <p className="mt-0 mb-0 text-600 text-sm">{item.date}</p>
    //                 </div>
    //             </div>
    //         </Card>
    //     );
    // };

    const itemTemplate = (product: any, index: number) => {
        return (
            <div className="col-12" key={index}>
                <Card className="mb-3 surface-ground">
                    <div className="flex align-items-center gap-4 p-2">
                        <div className="relative">
                            <Image
                                src={product.productImage}
                                alt={product.productName}
                                width="80"
                                height="80"
                                className="border-round-md shadow-2"
                                onError={(e: any) => e.target.src = '/image.png'}
                                preview
                            />
                            {/* <Badge
                                value={product.numberofItems}
                                severity="success"
                                className="absolute -top-1 -right-1"
                            /> */}
                        </div>

                        <div className="flex-1">
                            <div className="flex justify-content-between align-items-start mb-2">
                                <h4 className="m-0 text-900 font-medium">{product.productName}</h4>
                                <Tag value={`₹${product.total}`} severity="success" className="font-bold" />
                            </div>

                            <div className="flex gap-0 mb-2">
                                <Chip label={product.productQuantity} className="bg-blue-100 text-blue-800" />
                                <Chip label='-' className="bg-blue-100 text-blue-800" />
                                <Chip label={`${product.numberofItems} Items`} className="bg-orange-100 text-orange-800" />
                            </div>

                            <p className="text-600 text-sm m-0">
                                ₹{product.productPrice} × {product.numberofItems} =
                                <span className="font-semibold text-green-600 ml-1">₹{product.total}</span>
                            </p>
                        </div>
                    </div>
                </Card>
            </div>
        );
    };

    const sidebarHeader = (
        <div className="flex align-items-center gap-2">
            <i className="pi pi-receipt text-2xl text-primary"></i>
            <span className="text-xl font-bold text-primary">Order Details</span>
        </div>
    );

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            position="right"
            style={{ width: '28rem' }}
            header={sidebarHeader}
            className="order-sidebar"
        >
            <div className="h-full overflow-auto">
                {loading ? (
                    <div className="flex flex-column align-items-center justify-content-center h-20rem">
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                        <p className="mt-3 text-600">Loading order details...</p>
                    </div>
                ) : order ? (
                    <div className="flex flex-column gap-4">
                        {/* Order Overview Card */}
                        <Card className="shadow-3 surface-ground">
                            <div className="text-center mb-3">
                                <Tag value={order.orderId || 'ORD-12345'} severity="info" className="text-lg p-2 font-bold" />
                                <p className="text-600 mt-2 mb-0">Order placed by <strong>{order.name}</strong></p>
                                <p className="text-600 mt-1 mb-0">{order.phoneNumber}</p>
                            </div>

                            <Divider />

                            <div className="grid text-center">
                                <div className="col-6">
                                    <div className="text-2xl font-bold text-green-500">₹{order.orderTotal}</div>
                                    <div className="text-600 text-sm">Total Amount</div>
                                </div>
                                <div className="col-6">
                                    <div className="text-2xl font-bold text-blue-500">{order.orderProducts?.length || 0}</div>
                                    <div className="text-600 text-sm">Items</div>
                                </div>
                            </div>
                        </Card>

                        {/* Order Status Timeline */}
                        {/* <Card title="📦 Order Status" className="shadow-2">
                            <Timeline
                                value={orderStatusEvents}
                                align="alternate"
                                className="customized-timeline"
                                marker={customizedMarker}
                                content={customizedContent}
                            />
                        </Card> */}

                        {/* Pricing Breakdown */}
                        <Accordion className="shadow-2">
                            <AccordionTab header="💰 Pricing Breakdown">
                                <div className="flex flex-column gap-3">
                                    <div className="flex justify-content-between">
                                        <span className="text-600">Subtotal</span>
                                        <span className="font-semibold">₹{order.subTotal}</span>
                                    </div>
                                    <div className="flex justify-content-between">
                                        <span className="text-600">Delivery Fee</span>
                                        <span className="font-semibold">₹{order.deliveryPrice}</span>
                                    </div>
                                    <div className="flex justify-content-between">
                                        <span className="text-600">Margin Fee</span>
                                        <span className="font-semibold">₹{order.platformFee || 0}</span>
                                    </div>
                                    {order.discount > 0 && (
                                        <div className="flex justify-content-between">
                                            <span className="text-600">Discount</span>
                                            <span className="font-semibold text-green-600">-₹{order.discount}</span>
                                        </div>
                                    )}
                                    {order.promoCode && (
                                        <div className="flex justify-content-between">
                                            <span className="text-600">Promo Applied</span>
                                            <Chip label={order.promoCode} className="bg-green-100 text-green-800" />
                                        </div>
                                    )}
                                    <Divider className="my-2" />
                                    <div className="flex justify-content-between text-xl font-bold">
                                        <span>Total</span>
                                        <span className="text-green-600">₹{order.orderTotal}</span>
                                    </div>
                                </div>
                            </AccordionTab>
                        </Accordion>

                        {/* Delivery Address */}
                        <Card title="📍 Delivery Address" className="shadow-2">
                            <div className="bg-blue-50 p-3 border-round">
                                <p className="m-0 text-700 font-medium">{order.name}</p>
                                <p className="m-0 text-600 mt-2">{order.address}</p>
                                <div className="flex gap-2 mt-2">
                                    <Chip label={`PIN: ${order.pincode}`} className="bg-blue-100 text-blue-800" />
                                    <Chip label={order.phoneNumber} className="bg-gray-100 text-gray-800" />
                                </div>
                            </div>
                        </Card>

                        {/* Order Items */}
                        <Card title="🛍️ Order Items" className="shadow-2">
                            <DataView
                                value={order.orderProducts}
                                itemTemplate={itemTemplate}
                                paginator={false}
                            />
                        </Card>

                        {/* Action Buttons */}
                        {/* <div className="flex gap-2 mt-4">
                            <Button
                                label="Track Order"
                                icon="pi pi-map-marker"
                                className="flex-1"
                                severity="info"
                            />
                            <Button
                                label="Support"
                                icon="pi pi-headphones"
                                className="flex-1"
                                severity="help"
                            />
                        </div> */}
                    </div>
                ) : (
                    <div className="text-center mt-8">
                        <i className="pi pi-exclamation-triangle text-6xl text-400 mb-3"></i>
                        <p className="text-600">Order details not found</p>
                        <Button label="Refresh" icon="pi pi-refresh" severity="secondary" />
                    </div>
                )}
            </div>
        </Sidebar>
    );
};

export default OrderDetailsSidebar;